import showFlashes from '../libs/flashes'

export default function(context) {
    showFlashes().catch((a) => {
        console.error(a)
    })
}
